const initialState = {
    isOpen: false,
    isActive: false,
    showProvinceOptions: false, 
    showCityOptions: false,
    provinces: [],
    provinceSelectedTxt: '',  // Input
    provinceErr: '',
    provinceSelectedId: false,
    cities: [],
    citySelectedTxt: '', // Input
    cityErr: '',
    citySelectedId: false,
    address: '', // Input
    addressErr: '',
    plate: '', // Input
    plateErr: '',
    unit: '', // Input
    postalCode: '', // Input
    postalCodeErr: '',
};
const modalAddCustomAddress = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_ADD_CUSTOM_ADDRESS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalAddCustomAddress;
